import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useSearchParams } from "react-router-dom";
import { useKeyDown } from "../hooks/useKeyDown";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormLabel-root": {
			transform: "translate(14px, -6px) scale(0.75) ",
			backgroundColor: "#FFFF",
			transition: "none !important",
			left: -3.5,
			padding: "0 5px",
		},

		"& .MuiInputBase-input": {
			color: "black",
			paddingRight: 45,
		},
	},
}));

type Props = {
	searchData: Function;
};
// MuiGrid-item
export const DownHoursFilter = ({ searchData }: Props) => {
	const classes = useStyles();
	const { onKeyDownDownHours } = useKeyDown({ searchData });
	//routes
	const [searchParams, setSearchParams] = useSearchParams();
	const downHours = searchParams.get("downHours") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("downHours", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div style={{ position: "relative" }}>
			<TextField
				className={classes.root}
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				type="number"
				label="Down hours"
				variant="outlined"
				margin="dense"
				onKeyDown={onKeyDownDownHours}
				value={downHours}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
			/>
			<>
				<i
					className="fa fa-keyboard"
					style={{
						position: "absolute",
						right: 17,
						top: 20,
						cursor: "pointer",
					}}
				></i>
			</>
		</div>
	);
};
